import { render, staticRenderFns } from "./revmopeRepo.vue?vue&type=template&id=adc94202&scoped=true&"
import script from "./revmopeRepo.vue?vue&type=script&lang=js&"
export * from "./revmopeRepo.vue?vue&type=script&lang=js&"
import style0 from "./revmopeRepo.vue?vue&type=style&index=0&id=adc94202&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc94202",
  null
  
)

export default component.exports